// extracted by mini-css-extract-plugin
export var alignBaseline = "_3-9";
export var alignCenter = "_3-5";
export var alignFlexEnd = "_3-7";
export var alignFlexStart = "_3-6";
export var alignSelfBaseline = "_3-e";
export var alignSelfCenter = "_3-a";
export var alignSelfFlexEnd = "_3-c";
export var alignSelfFlexStart = "_3-b";
export var alignSelfStretch = "_3-d";
export var alignStretch = "_3-8";
export var column = "_3-2";
export var columnReverse = "_3-4";
export var flex = "_3-0";
export var justifyCenter = "_3-f";
export var justifyFlexEnd = "_3-h";
export var justifyFlexStart = "_3-g";
export var justifySpaceAround = "_3-j";
export var justifySpaceBetween = "_3-i";
export var justifySpaceEvenly = "_3-k";
export var row = "_3-1";
export var rowReverse = "_3-3";
export var wrapNowrap = "_3-m";
export var wrapWrap = "_3-l";
export var wrapWrapReverse = "_3-n";